import { render, staticRenderFns } from "./HomeWrapper.vue?vue&type=template&id=0b5ece13&scoped=true&"
import script from "./HomeWrapper.vue?vue&type=script&lang=js&"
export * from "./HomeWrapper.vue?vue&type=script&lang=js&"
import style0 from "./HomeWrapper.vue?vue&type=style&index=0&id=0b5ece13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5ece13",
  null
  
)

export default component.exports